// Should by use with input mixins in inputs components
export const observerField = {
  computed: {
    changedContextData: function() {
      if (this.isFormContext()) {
        return this.$store.state.formPayload.results
      }
      return this.getParent().editedItem;
    }
  },
  methods:{
    getValueField(fieldInterface) {
      if (this.isFormContext()) {
        return this.$store.state.formPayload.results.find(values => values.order == fieldInterface.order).value
      }
      return this.changedContextData[fieldInterface.order]
    },
  }
}
